export default {
  PX: 'px',
  PERCENT: '%',
};
